// import { MaterialUIComponentsNavigation } from "../pages/documentation/material-ui-components/MaterialUIComponentsNavigation";

const navigationConfig = [
  {
    id: "Pages",
    title: "Simulator",
    type: "group",
    children: [


      {
        id: "Errors",
        title: "Design",
        type: "collapse",
        icon: "domain", // "warning",
        badge: {
          title: "new",
          bg: "#513E8A",
          fg: "#FFFFFF",
        },
        children: [
          {
            id: "404",
            title: "Templates",
            type: "item",
            url: "/pages/errors/error-404",
            exact: true,
          },
          {
            id: "500",
            title: "Script",
            type: "item",
            url: "/script",
            exact: true,
          },
        ],
      },
      {
        id: "About",
        title: "View",
        type: "item",
        icon: "visibility",
        url: "/view",
        exact: true,
      },
      {
        id: "Run",
        title: "Check & Run",
        type: "item",
        icon: "code",
        url: "/run",
        exact: true,
      },
      {
        id: "About",
        title: "Postprocessing",
        type: "item",
        icon: "data_thresholding",
        url: "/pages/about",
        exact: true,
      },
    ],
  },
  {
    id: "divider-1",
    type: "divider",
  },
  {
    id: "Main",
    title: "My Workspace",
    type: "group",
    children: [
      {
        id: "dashboard",
        title: "Dashboard",
        type: "item",
        icon: "apps",
        url: "/",
        exact: true,
      },
      {
        id: "Authentication",
        title: "Authentication",
        type: "collapse",
        icon: "lock",
        children: [
          {
            id: "Login",
            title: "Login",
            type: "item",
            url: "/pages/auth/login",
            exact: true,
          },
          {
            id: "Register",
            title: "Register",
            type: "item",
            url: "/pages/auth/register",
            exact: true,
          },
          {
            id: "Forgot Password",
            title: "Forgot Password",
            type: "item",
            url: "/pages/auth/forgot-password",
            exact: true,
          },
        ],
      },
      {
        id: "posts",
        title: "Tasks",
        type: "collapse",
        icon: "file_copy",
        badge: {
          title: "2",
          bg: "#525E8A",
          fg: "#FFFFFF",
        },
        children: [
          {
            id: "all posts",
            title: "All Tasks",
            type: "item",
            url: "/pages/posts",
            exact: true,
          },
          {
            id: "add post",
            title: "Add Task",
            type: "item",
            url: "/pages/posts/add-post",
            exact: true,
          },
        ],
      },
      {
        id: "calendar",
        title: "Calendar",
        type: "item",
        icon: "event",
        url: "/pages/calendar",
        exact: true,
      },
    ],
  },

  {
    id: "divider-2",
    type: "divider",
  },
  {
    id: "Documentation",
    title: "DOCUMENTATION",
    type: "group",
    children: [
      // {
      //   id: "Material UI Components",
      //   title: "Material UI Components",
      //   type: "collapse",
      //   icon: "layers",
      //   children: [...MaterialUIComponentsNavigation]
      // },
      {
        id: "docs",
        title: "CheatSheet",
        type: "link",
        icon: "terminal",
        url: "https://vlab.daneshpark.org/doc.html",
        exact: true,
      },
    ],
  },
  // {
  //   id: "dashboard",
  //   title: "Dashboard",
  //   type: "item",
  //   icon: "dashboard",
  //   url: "/",
  //   exact: true
  // },
  // {
  //   id: "pages",
  //   title: "Pages",
  //   type: "group",
  //   icon: "pages",
  //   children: [
  //     {
  //       id: "all pages",
  //       title: "Pages",
  //       type: "collapse",
  //       icon: "stars",
  //       badge: {
  //         title: "new",
  //         bg: "#525E8A",
  //         fg: "#FFFFFF"
  //       },
  //       children: [
  //         {
  //           id: "about",
  //           title: "About",
  //           type: "item",
  //           icon: "info",
  //           url: "/pages/about",
  //           exact: true
  //         },
  //         {
  //           id: "contact",
  //           title: "Contact",
  //           type: "item",
  //           icon: "group",
  //           url: "/pages/contact",
  //           exact: true
  //         }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   id: "divider-1",
  //   type: "divider"
  // },
  // {
  //   id: "oftadeh-github",
  //   title: "Oftadeh Github",
  //   type: "link",
  //   icon: "link",
  //   url: "https://github.com/mohammadoftadeh",
  //   target: "_blank",
  //   badge: {
  //     title: "git",
  //     bg: "green",
  //     fg: "#FFFFFF"
  //   }
  // }
];

export default navigationConfig;
